import Vue from 'vue';
import * as SvgIcon from 'vue-svgicon';
import '~/assets/svg/bundle';

Vue.use(SvgIcon, {
  tagName: 'svgicon'
});
